import React, { useState, useContext } from "react";
import waiter from "../Images/waiter.png";
import delivery from "../Images/delivery.png";
import { RiLogoutCircleLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { BsBoxes } from "react-icons/bs";
import { FcBusinessman } from "react-icons/fc";
import { MdReceiptLong } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { GiRoundTable } from "react-icons/gi";
import { FaWhatsappSquare } from "react-icons/fa";
import { GiCash } from "react-icons/gi";
import { FaFileUpload } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { MdLogout } from "react-icons/md";
import { IoIosListBox } from "react-icons/io";
import { logIn } from "../Redux/Action";
import { AuthContext } from "../context/AuthContext";
import { setDivision } from "../Redux/Action/division";
import { setActiveTab } from "../Redux/Action/activeTab"

const HomePageNavbarFinancials = () => {
  const navigate = useNavigate();

  const { setAuthUser } = useContext(AuthContext);

  const [showDropdown, setShowDropdown] = useState(false);
  const state = useSelector((state) => state.changeTheState);
  const [activeTabs, setActiveTabs] = useState("sales");
  const dispatch = useDispatch();
  function logOut() {
    dispatch(logIn([]));
    dispatch(setDivision(""));
    dispatch(setActiveTab(""))
    navigate("/");
    setAuthUser(null);
  }
  return (
    <div>
      <div className="px-2 pt-2">
        <div className="flex border-b border-gray-300">
          <button
            onClick={() => {
              dispatch(setActiveTab("sales"))
              setActiveTabs("sales")
            }}
            className={`px-6 py-3 font-medium transition-all duration-200 border-b-4 ${
              activeTabs === "sales"
                ? "border-blue-700 text-blue-700 bg-blue-50"
                : "border-transparent text-gray-600 hover:bg-gray-100"
            }`}
          >
            Sales
          </button>

          <button
            onClick={() => {
                           dispatch(setActiveTab("inventory")) 
              setActiveTabs("inventory")
            }}
            className={`px-6 py-3 font-medium transition-all duration-200 border-b-4 ${
              activeTabs === "inventory"
                ? "border-blue-700 text-blue-700 bg-blue-50"
                : "border-transparent text-gray-600 hover:bg-gray-100"
            }`}
          >
            Inventory
          </button>

          <button
            onClick={() => {
               dispatch(setActiveTab("financials")) 
              setActiveTabs("financials")
            }}
            className={`px-6 py-3 font-medium transition-all duration-200 border-b-4 ${
              activeTabs === "financials"
                ? "border-blue-700 text-blue-700 bg-blue-50"
                : "border-transparent text-gray-600 hover:bg-gray-100"
            }`}
          >
            Financials
          </button>
        </div>
      </div>

      {activeTabs === "sales" && (
        <div className="w-full h-auto flex flex-row mb-1 mt-1 overflow-auto">
          {/* <div
                 className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
                 onClick={() => {
                   navigate("/Inventory");
                 }}
               >
                 <BsBoxes size={50} className="text-yellow-500" />
                 <p className="text-xs font-bold">Inventory</p>
               </div> */}

          {/* <div
                 className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
                 onClick={() => {
                   navigate("/UploadCategoryImage");
                 }}
               >
                 <FaFileUpload size={50} className="text-yellow-500" />
                 <p className="text-xs font-bold">Upload Image</p>
               </div> */}

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/CashPOS");
            }}
          >
            <FcBusinessman size={50} />
            <p className="text-xs font-bold">Cash POS</p>
          </div>
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/CreditPOS");
            }}
          >
            <FcBusinessman size={50} />
            <p className="text-xs font-bold">Credit POS</p>
          </div>
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/CreditNoteCash");
            }}
          >
            <FcBusinessman size={50} />
            <p className="text-xs font-bold">Cash Sale Credit Note</p>
          </div>
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/CreditNoteInvoice");
            }}
          >
            <FcBusinessman size={50} />
            <p className="text-xs font-bold">Credit Note Invoice</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              alert("This Service will be available soon");
            }}
          >
            <img src={delivery} alt="logo" className="w-[50px] " />
            <p className="text-xs font-bold">Delivery</p>
          </div>
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/Receipt");
            }}
          >
            <MdReceiptLong size={50} />
            <p className="text-xs font-bold">Receipts</p>
          </div>
          <div
            className="relative rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300   w-24 flex flex-col items-center "
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <TbReportSearch size={50} />
            <p className="text-xs font-bold">Reports</p>
            {showDropdown && (
              <div className="w-[250px] fixed  mt-20 ml-35 left-[350px] lg:left-[580px] bg-white border border-gray-300 rounded-md shadow-lg z-50">
                <aside className="flex flex-col items-start">
                  <div
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                    onClick={() => {
                      navigate("/ZandXReport");
                    }}
                  >
                    Z and X Report
                  </div>
                  <div
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                    onClick={() => {
                      navigate("/SalesReport");
                    }}
                  >
                    Sales Report
                  </div>
                  <div
                    onClick={() => {
                      navigate("/ReceiptReports");
                    }}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                  >
                    Receipt
                  </div>
                  {/* <div className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left">
                         Stock Movement Report
                       </div>
                       <div className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left">
                         Pickups Report
                       </div> */}
                </aside>
              </div>
            )}
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={logOut}
          >
            <RiLogoutCircleLine size={50} />
            <p className="text-xs font-bold">Logout</p>
          </div>
        </div>
      )}

      {activeTabs === "inventory" && (
        <div className="w-full h-auto flex flex-row mb-1 mt-1 overflow-auto">
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/Inventory");
            }}
          >
            <BsBoxes size={50} className="text-yellow-500" />
            <p className="text-xs font-bold">Inventory</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/UploadCategoryImage");
            }}
          >
            <FaFileUpload size={50} className="text-yellow-500" />
            <p className="text-xs font-bold">Upload Image</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/POPROCESSING");
            }}
          >
            {/* <FaFileUpload size={50} className="text-blue-500" /> */}
            <p className="text-xs font-bold">Purchase Order</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={() => {
              navigate("/GRNPROCESSING");
            }}
          >
            {/* <FaFileUpload size={50} className="text-blue-500" /> */}
            <p className="text-xs font-bold">GRN</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/GRNPROCESSING");
            // }}
          >
            {/* <FaFileUpload size={50} className="text-blue-500" /> */}
            <p className="text-xs font-bold">KITCHEN SUPPLY PROCESS</p>
          </div>

          <div
            className="relative rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300   w-24 flex flex-col items-center "
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <TbReportSearch size={50} />
            <p className="text-xs font-bold">Reports</p>
            {showDropdown && (
              <div className="w-[250px] fixed  mt-20 ml-35 left-[350px] lg:left-[580px] bg-white border border-gray-300 rounded-md shadow-lg z-50">
                <aside className="flex flex-col items-start">
                  <div
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                    onClick={() => {
                      navigate("/ZandXReport");
                    }}
                  >
                    Z and X Report
                  </div>
                  <div
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                    onClick={() => {
                      navigate("/SalesReport");
                    }}
                  >
                    Sales Report
                  </div>
                  <div
                    onClick={() => {
                      navigate("/ReceiptReports");
                    }}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left"
                  >
                    Receipt
                  </div>
                  {/* <div className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left">
                         Stock Movement Report
                       </div>
                       <div className="px-4 py-2 cursor-pointer hover:bg-gray-100 w-[100%] text-left">
                         Pickups Report
                       </div> */}
                </aside>
              </div>
            )}
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={logOut}
          >
            <RiLogoutCircleLine size={50} />
            <p className="text-xs font-bold">Logout</p>
          </div>
        </div>
      )}

      {activeTabs === "financials" && (
        <div className="w-full h-auto flex flex-row mb-1 mt-1 overflow-auto">
          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Chart of Accounts </p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Debtors Related</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Creditors Related</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Petty Cash</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Bank Transactions</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Financial Statements</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            // onClick={() => {
            //   navigate("/UploadCategoryImage");
            // }}
          >
            <p className="text-xs font-bold">Financial Dashboards</p>
          </div>

          <div
            className="rounded-md shadow-xl ml-4 cursor-pointer text-center p-2  py-4  bg-slate-300  hover:bg-slate-400 hover:text-white w-24 flex flex-col items-center"
            onClick={logOut}
          >
            <RiLogoutCircleLine size={50} />
            <p className="text-xs font-bold">Logout</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePageNavbarFinancials;
